//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name:'qSOFA',
  data() {
    return {
      defaultJson:{
        "Respiratory Rate ≥ 22": "Respiratory Rate ≥ 22",
        "Altered Mentation": "Altered Mentation",
        "Consider Sepsis": "Consider Sepsis",
        "Systolic Blood Pressure ≤ 100 mmHg": "Systolic Blood Pressure ≤ 100 mmHg"
      },
      form:{
        sbp:'0',
        respiratory:'0',
        gcs:'0',
      },
      hasScore:false,
      disabled:false,
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else { 
            form[key] = Number(form[key])
          }
        }
      }
      if (!flag) {
        self.hasScore = false
        return ''
      } else {
        // gcs + sbp + respiratory
        let result = form.gcs + form.sbp + form.respiratory
        self.hasScore = true
        return String(result)
      }
    }
  },
  
  
}



// WEBPACK FOOTER //
// ./src/pages/formulas/ID/qSOFA.vue